import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { panelTypes } from '../../../../common/panel/constants'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import {
  selectKeyFinancialById,
  selectKeyFinancials,
  selectLoading,
} from '../../store/slice'
import { PercentChange } from './PercentChange'
import { Trendline } from './Trendline'
import { UnitCell } from './UnitCell'
import { Value } from './Value'
import { COLUMN_IDS } from './helper'
import classes from './index.module.scss'

export const KeyFinancials = ({ panelType }) => {
  const { fiscalYearEnd } = useSelector(selectCompanyInfo)
  const data = useSelector(selectKeyFinancials())
  const isLoading = useSelector(selectLoading('keyFinancials'))

  const isFullSize = panelType === panelTypes.FULL_SIZE

  const schema = Object.keys(COLUMN_IDS).map((key) => {
    const colId = COLUMN_IDS[key]
    let title = 'companySummary.keyFinancials.' + key
    if (colId === COLUMN_IDS.YEAR) {
      const year = data?.[0]?.values?.at(-1)?.realYear
      title = year || new Date(fiscalYearEnd).getFullYear()
    }

    return {
      colId,
      title,
      isI18n: colId !== COLUMN_IDS.YEAR,
      thStyle: {
        justifyContent:
          colId === COLUMN_IDS.TRENDLINE
            ? 'center'
            : colId === COLUMN_IDS.YEAR
            ? 'flex-end'
            : 'unset',
      },
      parentThStyle: {
        paddingRight: isFullSize && colId === COLUMN_IDS.YEAR ? '5%' : '',
        paddingLeft:
          isFullSize && colId === COLUMN_IDS.PERCENT_CHANGE ? '5%' : '',
      },
      tdStyle: {
        whiteSpace: colId === COLUMN_IDS.INDICATOR ? '' : 'nowrap',
        width: colId === COLUMN_IDS.INDICATOR ? '36%' : 'unset',
        paddingRight: isFullSize && colId === COLUMN_IDS.YEAR ? '5%' : '',
        paddingLeft:
          isFullSize && colId === COLUMN_IDS.PERCENT_CHANGE ? '5%' : '',
      },
      render: (data, { rowId }) => {
        switch (colId) {
          case COLUMN_IDS.INDICATOR:
            return (
              <TextEllipsisStaticLine
                text={data}
                isI18n={false}
                lineClamp={1}
              />
            )
          case COLUMN_IDS.UNIT:
            return <UnitCell data={data} />
          case COLUMN_IDS.YEAR:
            return <Value rowId={rowId} />
          case COLUMN_IDS.PERCENT_CHANGE:
            return <PercentChange data={data} />
          case COLUMN_IDS.TRENDLINE:
            return <Trendline data={data} />
          default:
            return data
        }
      },
    }
  })

  return (
    <Element className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : !data || !data.length ? (
        <Notification />
      ) : (
        <Table
          ids={data.map((i) => i.ratioCode)}
          getDataFromRedux={selectKeyFinancialById}
          isLoading={isLoading}
          schema={schema}
        />
      )}
    </Element>
  )
}
